import * as Sentry from '@sentry/react'

if (process.env.NODE_ENV !== 'development') {
    Sentry.init({
        dsn: 'https://f02caab71e7044159d6f15acd30a8719@o135273.ingest.sentry.io/1491619',

        // Alternatively, use `process.env.npm_package_version` for a dynamic release version
        // if your build tool supports it.
        release: `${process.env.REACT_APP_PROJECT_NAME ?? 'unknownspa'}@${
            process.env.REACT_APP_VERSION ?? 'unknown'
        }`,

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.1,
        environment: process.env.REACT_APP_ENVIRONMENT_NAME,
        // According to documentation, using strings will do a partial match. For exact matches, use a regex.
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/filtering/
        ignoreErrors: [
            // Page not found errors are often crawlers
            /Page not found:/,

            // Storage errors on broken browsers
            `Cannot read properties of null (reading 'getItem')`,

            // Service worker installation errors
            `Failed to register a ServiceWorker for scope`,

            // These errors are thrown when apollo server is temporary unavailable
            // and quickly eats trough Sentry's budget
            /JSON\.?[Pp]arse/,
            'Internal server error',
            'Unexpected token < in JSON at position 0',

            // Probably Apollo that cannot connect (yet) to Magento (see retryingPromise and HttpLink)
            `Verify the entity and try again`,

            // Catched in ErrorBoundary, but too vague
            `Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.`,
        ],
        denyUrls: [
            // BlueConic
            /bc.pme-legend.com/,
        ],
        debug: process.env.NODE_ENV === 'development',
        enabled: true,

        integrations: [
            new Sentry.BrowserTracing({
                routingInstrumentation:
                    Sentry.reactRouterV5Instrumentation(history),
            }),
        ],
    })
}
